/* =========================================================
   NXG FIT Premium Cylinder Carousel
   Desktop Arrows + Mouse Drag
   Mobile Swipe
========================================================= */

document.addEventListener("DOMContentLoaded", () => {

    const carousel = document.querySelector(".nxg-cylinder");

    if (!carousel) return;

    const wrapper = carousel.closest(".nxg-cylinder-wrapper");

    if (!wrapper) return;

    const items = [...carousel.querySelectorAll(".nxg-item")];

    const prevBtn = wrapper.querySelector(".nxg-arrow.prev");
    const nextBtn = wrapper.querySelector(".nxg-arrow.next");

    let current = 1;

    const total = items.length;

    if (total === 0) return;


    /* =====================================================
       POSITION
    ===================================================== */

    function normalize(index) {

        return (index + total) % total;

    }


    /* =====================================================
       CLEAR CLASSES
    ===================================================== */

    function clearClasses(item) {

        item.classList.remove(
            "is-center",
            "is-left",
            "is-right",
            "is-back-left",
            "is-back-right",
            "is-hidden"
        );

    }


    /* =====================================================
       RENDER
    ===================================================== */

    function render() {

        items.forEach(clearClasses);

        items.forEach((item, i) => {

            let diff = normalize(i - current);

            if (diff > total / 2) {

                diff -= total;

            }

            switch (diff) {

                case 0:

                    item.classList.add("is-center");

                    break;

                case -1:

                    item.classList.add("is-left");

                    break;

                case 1:

                    item.classList.add("is-right");

                    break;

                case -2:

                    item.classList.add("is-back-left");

                    break;

                case 2:

                    item.classList.add("is-back-right");

                    break;

                default:

                    item.classList.add("is-hidden");

            }

        });

    }


    /* =====================================================
       NEXT
    ===================================================== */

    function next() {

        current++;

        if (current >= total) {

            current = 0;

        }

        render();

    }


    /* =====================================================
       PREVIOUS
    ===================================================== */

    function prev() {

        current--;

        if (current < 0) {

            current = total - 1;

        }

        render();

    }


    /* =====================================================
       ARROWS
    ===================================================== */

    if (nextBtn) {

        nextBtn.addEventListener("click", next);

    }

    if (prevBtn) {

        prevBtn.addEventListener("click", prev);

    }


    /* =====================================================
       MOUSE DRAG
    ===================================================== */

    let isDragging = false;
    let startX = 0;
    let currentX = 0;


    wrapper.addEventListener("mousedown", (e) => {

        /* Don't drag when clicking a button or link */

        if (
            e.target.closest("button") ||
            e.target.closest("a")
        ) {
            return;
        }

        isDragging = true;

        startX = e.clientX;

        currentX = e.clientX;

        wrapper.style.cursor = "grabbing";

    });


    window.addEventListener("mousemove", (e) => {

        if (!isDragging) return;

        currentX = e.clientX;

    });


    window.addEventListener("mouseup", () => {

        if (!isDragging) return;

        isDragging = false;

        wrapper.style.cursor = "grab";

        const distance = currentX - startX;

        if (Math.abs(distance) < 60) return;

        if (distance < 0) {

            next();

        } else {

            prev();

        }

    });


    /* =====================================================
       MOBILE TOUCH SWIPE
    ===================================================== */

    let touchStartX = 0;
    let touchStartY = 0;

    let touchEndX = 0;
    let touchEndY = 0;


    wrapper.addEventListener(
        "touchstart",
        (e) => {

            if (e.touches.length !== 1) return;

            touchStartX = e.touches[0].clientX;

            touchStartY = e.touches[0].clientY;

            touchEndX = touchStartX;

            touchEndY = touchStartY;

        },
        { passive: true }
    );


    wrapper.addEventListener(
        "touchmove",
        (e) => {

            if (e.touches.length !== 1) return;

            touchEndX = e.touches[0].clientX;

            touchEndY = e.touches[0].clientY;

        },
        { passive: true }
    );


    wrapper.addEventListener(
        "touchend",
        () => {

            const distanceX =
                touchEndX - touchStartX;

            const distanceY =
                touchEndY - touchStartY;


            /* Ignore vertical scrolling */

            if (
                Math.abs(distanceY) >
                Math.abs(distanceX)
            ) {

                return;

            }


            /* Minimum swipe distance */

            if (Math.abs(distanceX) < 50) {

                return;

            }


            /* Swipe LEFT → NEXT */

            if (distanceX < 0) {

                next();

            }

            /* Swipe RIGHT → PREVIOUS */

            else {

                prev();

            }

        },
        { passive: true }
    );


    /* =====================================================
       KEYBOARD
    ===================================================== */

    window.addEventListener("keydown", (e) => {

        if (e.key === "ArrowRight") {

            next();

        }

        if (e.key === "ArrowLeft") {

            prev();

        }

    });


    /* =====================================================
       RESIZE
    ===================================================== */

    window.addEventListener("resize", () => {

        render();

    });


    /* =====================================================
       INITIAL
    ===================================================== */

    wrapper.style.cursor = "grab";

    render();

});